import { useStoredValue } from '@/features/proactive-agents/useStoredValue';

// The last accepted send, kept across reloads per admin so the page can show how far it has come
export type LastNudgeSend = { nudge_id: string; agent: string };

const parseLastSend = (stored: unknown): LastNudgeSend | null => {
  const send = stored as Partial<LastNudgeSend> | null;
  return typeof send?.nudge_id === 'string' && typeof send.agent === 'string'
    ? { nudge_id: send.nudge_id, agent: send.agent }
    : null;
};

export const useLastNudgeSend = (adminEmail: string) =>
  useStoredValue(`proactive-agents.last-nudge:${adminEmail}`, parseLastSend);
